const trimTrailingSlash = (url: string) => url.replace(/\/+$/, '');

/** Services append `/api/...` themselves; strip a trailing `/api` from env so `…:8003/api` does not double-prefix. */
const normalizeApiBase = (url: string | undefined): string => {
  if (!url) return '';
  let u = trimTrailingSlash(url.trim());
  if (u.endsWith('/api')) {
    u = u.slice(0, -4);
  }
  return u;
};

// Use literal property access for Vite compatibility
// This ensures that variables are correctly replaced during the build process
const VITE_API_URL = import.meta.env.VITE_API_URL || import.meta.env.REACT_APP_API_URL;
const VITE_AUTH_API_URL = import.meta.env.VITE_AUTH_API_URL || import.meta.env.REACT_APP_AUTH_API_URL;
const VITE_PAYMENTS_API_URL = import.meta.env.VITE_PAYMENTS_API_URL || import.meta.env.REACT_APP_PAYMENTS_API_URL;
const VITE_FILE_SERVER = import.meta.env.VITE_FILE_SERVER || import.meta.env.REACT_APP_FILE_SERVER || import.meta.env.REACT_APP_FILE_SERVER_URL;

/** Main backend API. */
const apiUrl = normalizeApiBase(VITE_API_URL) || window.location.origin;

/** File / static asset server. */
const fileServerUrl = normalizeApiBase(VITE_FILE_SERVER) || apiUrl;

/** Auth API base. */
const authUrl = normalizeApiBase(VITE_AUTH_API_URL) || apiUrl;

/** Payments API base. */
const paymentsUrl = normalizeApiBase(VITE_PAYMENTS_API_URL) || apiUrl;

export const environment = {
  NODE_ENV: import.meta.env.MODE || 'development',
  REACT_APP_API_URL: apiUrl,
  REACT_APP_FILE_SERVER_URL: fileServerUrl,
  REACT_APP_AUTH_API_URL: authUrl,
  REACT_APP_PAYMENTS_API_URL: paymentsUrl,
  REACT_APP_RAZORPAY_KEY_ID: import.meta.env.VITE_RAZORPAY_KEY_ID || import.meta.env.REACT_APP_RAZORPAY_KEY_ID || '',
  REACT_APP_SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN || import.meta.env.REACT_APP_SENTRY_DSN || '',
  REACT_APP_GOOGLE_ANALYTICS_ID: import.meta.env.VITE_GOOGLE_ANALYTICS_ID || import.meta.env.REACT_APP_GOOGLE_ANALYTICS_ID || '',
  REACT_APP_ENABLE_ANALYTICS: import.meta.env.VITE_ENABLE_ANALYTICS === 'true' || import.meta.env.REACT_APP_ENABLE_ANALYTICS === 'true',
  REACT_APP_ENABLE_ERROR_REPORTING: import.meta.env.VITE_ENABLE_ERROR_REPORTING === 'true' || import.meta.env.REACT_APP_ENABLE_ERROR_REPORTING === 'true',
  LOG_LEVEL: import.meta.env.VITE_LOG_LEVEL || 'INFO',
};

